import {Component,Inject,OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {Role,Statut,Workflow} from "@domain/admin/workflow/segment";
import {WorkflowAdminService} from "@services/admin/workflow/workflow-admin.service";
import {TranslateService} from "@ngx-translate/core";
import {first} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {SessionStorageService} from "@domain/common/services/session-storage.service";
import {VisualisationComponent} from "@components/admin/workflow/construction/visualisation/visualisation.component";
import {TypeCodeErreur} from "@domain/common/http/result";
import {Router} from "@angular/router";

/**
 * Composant de popup pour la modification d'un workflow
 */
@Component({
    selector: 'workflow-popup',
    templateUrl: './workflow-popup.component.html'
})
export class WorkflowPopupComponent implements OnInit {
    /** Workflow concerné */
    workflow: Workflow;

    /** liste des rôles possibles */
    listeRoles: Role[] = [];

    /** Liste des statuts possibles */
    listeStatuts: Statut[];

    /**
     * Constructeur
     */
    constructor(
        private workflowAdminService: WorkflowAdminService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private sessionStorageService: SessionStorageService,
        private dialogRef: MatDialogRef<WorkflowPopupComponent>,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) private data: { workflow: Workflow }
    ) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Si un workflow est fourni en paramètre
        if (this.data?.workflow) {
            //Récupération du workflow fourni
            this.workflow = new Workflow(this.data.workflow);
        } else {
            //Création d'un nouveau workflow
            this.workflow = new Workflow({
                libelle: null,
                organisme: null,
                commentaire: null,
                nombrePersonnesRattachees: 0,
                nombreSegmentsRattaches: 0
            });
        }

        //Appel au back pour obtention de la liste des rôles
        this.workflowAdminService.getRoles().subscribe(result => {
            //Purge de la liste des rôles
            this.listeRoles = [];

            //Vérifie si la liste des rôles collaborateur n'est pas vide
            if (result.data.listeRolesCollaborateur.length) {
                //Ajout des rôles dans la liste des rôles
                this.listeRoles = this.listeRoles.concat(result.data.listeRolesCollaborateur.map(r => { return { ...new Role(r), isSectionItem: true }}));
            }

            //Vérifie si la liste des rôles assistant n'est pas vide
            if (result.data.listeRolesAssistant.length) {
                //Ajout des rôles dans la liste des rôles
                this.listeRoles = this.listeRoles.concat(result.data.listeRolesAssistant.map(r => { return { ...new Role(r), isSectionItem: true }}));
            }

            //Vérifie si la liste des rôles responsable n'est pas vide
            if (result.data.listeRolesResponsable.length) {
                //Ajout des rôles dans la liste des rôles
                this.listeRoles = this.listeRoles.concat(result.data.listeRolesResponsable.map(r => { return { ...new Role(r), isSectionItem: true }}));
            }

            //Vérifie si la liste des rôles comptable n'est pas vide
            if (result.data.listeRolesComptable.length) {
                //Ajout des rôles dans la liste des rôles
                this.listeRoles = this.listeRoles.concat(result.data.listeRolesComptable.map(r => { return { ...new Role(r), isSectionItem: true }}));
            }

            //Vérifie si la liste des rôles fournisseur n'est pas vide
            if (result.data.listeRolesFournisseur.length) {
                //Ajout des rôles dans la liste des rôles
                this.listeRoles = this.listeRoles.concat(result.data.listeRolesFournisseur.map(r => { return { ...new Role(r), isSectionItem: true }}));
            }
        });

        //Chargement de la liste de statuts possibles
        this.workflowAdminService.getAllStatus().pipe(first()).subscribe(listeStatuts => this.listeStatuts = listeStatuts);
    }

    /**
     * Enregistrement de la notification
     */
    enregistrer(): void {
        this.workflowAdminService.saveWorkflow(this.workflow).pipe(first()).subscribe(result => {
            //Vérification du code d'erreur
            if (result.codeErreur == TypeCodeErreur.NO_ERROR || !result.codeErreur) {
                //Fermeture de la popup
                this.dialogRef.close(true);

                //Purge du SessionStorage pour forcer la mise à jour des filtres disponibles sur la page de visualisation des WF
                this.sessionStorageService.remove(VisualisationComponent.LISTE_CLASS_NAME,"listeFilters_0");
                this.sessionStorageService.remove(VisualisationComponent.LISTE_CLASS_NAME,"listeSelectedFilters_0");

                //Message de réussite
                this.toastrService.success(this.translateService.instant('global.success.enregistrement'));
            }
        });
    }

    /**
     * Création d'un segment vierge sur le workflow concerné
     */
    creerSegment(): void {
        //Fermeture de la popup
        this.dialogRef.close(true);

        //Ouverture de la page pour la création d'un nouveau segment
        this.router.navigate(['Admin/Workflow/Construction/Segment/0'], {
            state: {
                workflowId: this.data.workflow.id,
                workflowLibelle: this.data.workflow.libelle
            }
        });
    }
}
